import API_URLS from "@constants/api.urls";

import { getRequest, postRequest } from "../baseApi";

export const sendProject = data => postRequest(API_URLS.sendProject, data);

export const getAlredaySentUsers = parmas => getRequest(API_URLS.projAlredaySentTo, parmas);
